
var json = {
  filterDevice: [
    {
      title: '增加过滤设备',
      value: '1',
      typeList: [
        {
          title: '石英砂（超自来水级过滤）',
          value: '1',
          brand: [
            {value: '2', title: '国产优选'},
            {value: '1', title: '国产性价比'},
          ]
        },
        {
          title: '硅藻土（饮用水级过滤）',
          value: '2',
          brand: [
            {value: '2', title: '国产优选'},
            {value: '3', title: '国际顶级'},
          ]
        },
        {
          title: '珍珠岩（饮用级别过滤）',
          value: '3',
          brand: [
            {value: '2', title: '国产优选'},
            {value: '3', title: '国际顶级'},
          ]
        },
      ]
    },
    {
      title: '不需要过滤设备',
      value: '',
    },
  ],
  disinfectDevice: [
    {
      title: '增加消毒设备',
      value: '1',
      typeList: [
        {
          title: '投药桶',
          value: '5',
        },
        {
          title: '中亚紫外线',
          value: '1',
        },
        {
          title: '次氯酸钠',
          value: '2',
        },
        {
          title: '铜银离子',
          value: '3',
        },
        {
          title: '臭氧消毒',
          value: '4',
        },
      ],
      brand: [
        {value: '2', title: '国产优选'},
        {value: '3', title: '国际顶级'},
      ]
    },
    {
      title: '不需要消毒设备',
      value: '',
    },
  ],
  constantDevice: [
    {
      title: ' 增加恒温设备',
      value: '1',
      typeList: [
        {
          title: '空气能加热',
          value: '1',
        },
        {
          title: '燃气锅炉加热',
          value: '2',
        },
      ],
      area: [
        {value: '1', title: '北方'},
        {value: '2', title: '中部'},
        {value: '3', title: '南方'},
        {value: '4', title: '西方'},
      ],
      brand: [
        {value: '2', title: '国产优选'},
        {value: '3', title: '国际顶级'},
      ]
    },
    {
      title: '不需要恒温设备',
      value: '',
    },
  ],
  removeWetDevice: [
    {
      title: '增加除湿设备',
      value: '1',
      typeList: [
        {
          title: '三集一体设备',
          value: '1',
        },
        {
          title: '顶吸式除湿机',
          value: '2',
        },
        {
          title: '落地式除湿机',
          value: '3',
        },
        {
          title: '排风扇换气',
          value: '4',
        },
      ],
      brand: [
        {value: '2', title: '国产优选'},
        {value: '1', title: '国产性价比'},
      ]
    },
    {
      title: '不需要除湿设备',
      value: '',
    },
  ],
};

export default json;



// WEBPACK FOOTER //
// ./src/utils/json.js